import { render, staticRenderFns } from "./PurchasesInvoiceForm.vue?vue&type=template&id=6bd120cc"
import script from "./PurchasesInvoiceForm.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports